import React from "react";

export default function Section({ id, title, subtitle, right, fullBleed = false, bgClass = "", children }) {
  return (
    <section id={id} className={`${bgClass} overflow-x-clip`}>
      <div className={`${fullBleed ? "max-w-7xl" : "max-w-7xl"} mx-auto min-w-0 max-w-full px-3 sm:px-4 py-4 md:py-5`}>
        <div className="mb-2.5 flex items-end justify-between gap-3">
          <div className="min-w-0">
            <h2 className="font-sans text-lg md:text-xl font-bold tracking-tight text-slate-900">{title}</h2>
            {subtitle && (
              <p className="mt-0.5 font-sans text-xs text-slate-600 sm:text-sm">{subtitle}</p>
            )}
          </div>
          {right}
        </div>
        {children}
      </div>
    </section>
  );
}
